import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const Permission = () => {
  const { t } = useTranslation()
  return (
      <div className="main-content-container px-4 pb-4 container-fluid">
          <div className="error">
              <div className="error__content">
                  <h2>403</h2>
                  <h3>{t("access_denied_title", { defaultValue: "Access denied" })}</h3>
                  <p>{t("access_denied_text", { defaultValue: "You don't have permission to access this page." })}</p>
                  <Link to="/">
                      <button className="btn btn-primary btn-pill"> {t("Go_Back")}</button>
                  </Link>
              </div>
          </div>
      </div>
  )
}

export default Permission